import { Component, Inject, OnInit, inject } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';
import { LayoutComponent } from '../../core/layout/layout.component';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelect, MatSelectChange, MatSelectModule } from '@angular/material/select';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatRadioModule } from '@angular/material/radio';
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';
import {
  AbstractControl,
  FormArray,
  FormBuilder,
  FormControl,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  ValidationErrors,
  ValidatorFn,
  Validators,
} from '@angular/forms';
import { InvoiceService } from '../../features/invoice/services/invoice.service';
import {
  PAYMENT_TERMS,
  PartnerTypesEnum,
  UNITTYPES,
} from '../../helpers/helper-file';
// import { InventoryItemService } from '../../features/inventory/services/inventory.service';
import { CreditDebitNoteService } from '../../features/credit-debit-note/services/credit-debit-note.service';
import { ToastrService } from 'ngx-toastr';
import { ActivatedRoute, Router } from '@angular/router';
import { Subject, debounceTime, distinctUntilChanged } from 'rxjs';
import {
  MatAutocompleteModule,
  MatAutocompleteSelectedEvent,
} from '@angular/material/autocomplete';
import { nonNegativeValidator, quantityValidator } from '../../shared/services/validations';
// import { WorkOrderService } from '../../features/workOrder/services/workOrder.service';
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogModule,
  MatDialogRef,
} from '@angular/material/dialog';
// import { ListBillingAddressDialog } from '../invoice-new/dialog-components/list-billing-address-dialog/list-billing-address-dialog.component';
// import { ListShippingAddressDialog } from '../invoice-new/dialog-components/list-shipping-address-dialog/list-shipping-address-dialog.component';
// import { BillingAddressDialog } from '../invoice-new/dialog-components/add-billing-address-dialog/billing-address-dialog.component';
// import { ShippingAddressDialog } from '../invoice-new/dialog-components/add-shipping-address-dialog/shipping-address-dialog.component';
// import { PreferenceService } from '../../shared/services/preference.service';
// import { CreateVendorDialog } from '../invoice-new/dialog-components-vendor/create-vendor-dialog/create-vendor-dialog.component';
import { ConfirmDialog } from '../../shared/components/confirm-dialog/confirm-dialog';
import { MatOptionModule } from '@angular/material/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatCheckboxModule } from '@angular/material/checkbox';
import {
  DateAdapter,
  MAT_DATE_FORMATS,
  MAT_DATE_LOCALE,
} from '@angular/material/core';
// import { CUSTOM_DATE_FORMATS } from '../../shared/services/date-format';
// import { CustomDateAdapter } from '../../shared/services/custom-date-adapter';
// import { PermissionDirective } from '../../shared/directives/permissions.directive';
// import { Permission } from '../../shared/services/permissions';
import { PurchaseOrderService } from '../../features/purchase-order/services/purchase-order.service';
import { VendorInvoiceService } from '../../features/vendor-invoice/services/vendor-invoice.service';
import { CurrencyAdjustmentService } from '../../features/currency-adjustment/services/currency-adjustment.service';
import { PreferenceCodeService } from '../../features/preference-code/services/preference-code.service';

@Component({
  selector: 'app-purchase-order-new',
  standalone: true,
  imports: [
    CommonModule,
    LayoutComponent,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    MatDatepickerModule,
    FormsModule,
    MatRadioModule,
    ReactiveFormsModule,
    NgxMatSelectSearchModule,
    MatAutocompleteModule,
    MatDialogModule,
    MatCheckboxModule,
    MatSelect,
    // PermissionDirective,
  ],
  providers: [
    // { provide: DateAdapter, useClass: CustomDateAdapter },
    // { provide: MAT_DATE_FORMATS, useValue: CUSTOM_DATE_FORMATS },
    { provide: MAT_DATE_LOCALE, useValue: 'en-GB' },
  ],
  templateUrl: './purchase-order-new.component.html',
  styleUrl: './purchase-order-new.component.scss',
})
export class PurchaseOrderNewComponent implements OnInit {
  // public arr = [1, 2, 3, 4, 5, 6, 7];
  currentDate: string;
  public vendorsData: any[] = [];
  public cutomersData: any[] = [];
  public billingAddressList: any[];
  public shippingAddressList: any[];
  accountData: any[] = [];
  paymentTermsValue = PAYMENT_TERMS;
  loading: boolean = false;
  public itemData: any[] = [];
  public filteredItemData: any[] = [];
  purchaseOrderForm: FormGroup;
  purchaseOrderData: any;
  AdminAddressData: any;
  purchaseOrderId: any;
  selectedVendorId: any;
  private searchSubject = new Subject<string>();
  allCurrencies: any;
  workOrders: any;
  filteredWorkOrders: any[] = [];
  workOrderControl = new FormControl('');
  workOrderSearchControl = new FormControl('');
  public selectedAddress: any = {};
  public selectedShippingAddress: any = {};
  isCustomerSelected: boolean = false;
  selectedCustomerId: number | null = null;
  readonly dialog = inject(MatDialog);
  vendorControl = new FormControl();
  customerControl = new FormControl();
  customerSearchSubject = new Subject<string>();
  selectedVendorTRN: any;
  prefix: any;
  projectId: number;
  purchaseOrderNo: any;
  newPurchaseOrderNo: any;
  addedItems: any[] = [];
  selectedCurrencyCode: string = 'AED';
  selectedCurrencyId: number;
  unitTypes: any = UNITTYPES;
  subSubjectList: string[] = [];
  public filteredSubSubjectList: string[] = [];
  newPurchaseItems: any[] = [];
  profileName: any;
  totalDiscount: any;
  // Permission = Permission;
  userName: any;
  private partnerTypes = PartnerTypesEnum;
  //Newly added code //
  subTotal: number;
  totalVat: number;
  grandTotal: number;
  additionalDiscount: number;
  // projectId: number;
  adminPartnerId = 0;
  isCancelling: boolean = false;
  amount: number;
  selectedWorkOrderDisplay: string = 'Select work order';
  thresholdExceeds: boolean = false;
  search: string | undefined;
  filter: {};
  status: string;

  constructor(
    private invoiceService: InvoiceService,
    // private itemService: InventoryItemService,
    private creditDebitNoteService: CreditDebitNoteService,
    private fb: FormBuilder,
    private toastr: ToastrService,
    private purchaseOrderService: PurchaseOrderService,
    private route: ActivatedRoute,
    private datePipe: DatePipe,
    private router: Router,
    private vendorInvoiceService: VendorInvoiceService,
    private currencyService: CurrencyAdjustmentService,
    // private workOrderService: WorkOrderService,
    private preferenceService: PreferenceCodeService
  ) {
    this.currentDate = new Date().toISOString().split('T')[0]; // Format as YYYY-MM-DD
    const loggedInUser: any = localStorage.getItem('loggedInUser');
    const userData = JSON.parse(loggedInUser);
    this.profileName = userData?.profileData?.profileName;
    this.userName = userData?.firstName;
    this.totalDiscount = 0;
    this.subTotal = 0;
    this.totalVat = 0;
    this.grandTotal = 0;
    this.additionalDiscount = 0;
  }
  
  ngOnInit(): void {
    this.initForm();
    this.fetchPartners();
    this.fetchWorkOrders();
    this.fetchItems();
    this.listCurrencies();
    this.fetchCustomers();
    this.addItem();
    this.purchaseOrderForm.get('currency')?.disable();
    
    this.route.paramMap.subscribe((params) => {
      const id = params.get('id');
      if (id) {
        this.purchaseOrderId = +id;
        this.loadPurchaseOrderData();
        this.calculateLogic();
      }
    });
    if (!this.purchaseOrderId) {
      // this.setAdminAddress();  
      this.preferenceCode();
    }

    this.searchSubject
      .pipe(debounceTime(600), distinctUntilChanged())
      .subscribe((searchTerm) => {
        this.fetchPartners(null, searchTerm);
      });

    this.workOrderControl.valueChanges
      .pipe(
        debounceTime(600), // Delay in ms before triggering the search
        distinctUntilChanged() // Prevent triggering if search term doesn't change
      )
      .subscribe((searchTerm) => {
        this.fetchWorkOrders(searchTerm);
      });

    // this.purchaseOrderForm
    //   .get('currency')
    //   ?.valueChanges.subscribe((selectedCurrencyId) => {
    //     const selectedCurrency = this.allCurrencies.find(
    //       (currency: { id: any }) => currency.id === selectedCurrencyId
    //     );
    //     this.selectedCurrencyCode = selectedCurrency?.currencyCode || 'AED'; // Fallback to AED
    //   });

    this.purchaseOrderForm
      .get('workorderId')
      ?.valueChanges.subscribe((selectedWorkOrderId) => {
        console.log('inside selectedWorkOrderId');
        this.fetchWorkOrderById(selectedWorkOrderId?.workOrderId);
      });

      this.purchaseOrderForm.get('items')?.valueChanges.subscribe(() => {
        this.calculateLogic();
      });  

    if (this.isCancelling) {
      this.preferenceCode();
    }
  }

  onVendorSearch(event: Event) {
    const input = event.target as HTMLInputElement;
    const searchTerm = input.value;
    this.searchSubject.next(searchTerm);
  }

  recalculateVatAndTotal(): void {
    const isVatEnabled = this.purchaseOrderForm.get('isVat')?.value;
    const totalAmount = this.getTotalAmount(); // Amount before VAT
    const additionalDiscount = this.getAdditionalDiscount();
    const vatAmount = this.getVAT(); // Get VAT based on the checkbox

    const grandTotal = totalAmount - additionalDiscount + vatAmount;

    this.purchaseOrderForm.patchValue({
      grandTotal: grandTotal,
      vatAmount: vatAmount,
    });

    this.items.controls.forEach((itemGroup: any) => {
      this.calculateAmount(itemGroup);
    });
  }

  initForm() {
    const today = new Date();
    const formattedDate = `${today.getDate().toString().padStart(2, '0')}/${(
      today.getMonth() + 1
    )
      .toString()
      .padStart(2, '0')}/${today.getFullYear()}`;
    this.purchaseOrderForm = this.fb.group({
      id: [this.purchaseOrderData?.id || ''],
      // PurchaseType: ['Supplier'],
      vendorId: [this.purchaseOrderData?.vendorId, Validators.required],
      purchaseOrderNo: [],
      // customerId: [],
      oldPurchaseOrderNo: [],
      // projectId: [null],
      // workorderId: [null, Validators.required],
      reference: [''],
      // paymentTerms: ['', Validators.required],
      currency: [this.selectedCurrencyId, Validators.required],
      // shipmentPreference: [''],
      subject: [''],
      selectedAddress: [],
      // organizationAddressId: [],
      items: this.fb.array([]),
      billDate: [
        this.purchaseOrderData?.billDate
          ? new Date(Number(this.purchaseOrderData.billDate))
              .toISOString()
              .split('T')[0]
          : formattedDate,
        Validators.required,
      ],
      trnNumber: [''],
      additionalDiscount: [
        0,
        [Validators.min(0), this.validateAdditionalDiscount.bind(this)],
      ],
      // discountType: ['flat', Validators.required],
      // isVat: [true, Validators.required],
    });
  }

  dateFilter = (date: Date | null): boolean => {
    if (!date) return false;
    const today = new Date();
    return (
      date.getFullYear() === today.getFullYear() &&
      date.getMonth() === today.getMonth() &&
      date.getDate() === today.getDate()
    );
  };

  onVendonSelected(event: MatSelectChange) {
    const selectedVendorId = event.value;
    this.selectedVendorId = selectedVendorId;
  }

  private formatToLocalDate(date: any): string {
    const localDate = new Date(date);
    const year = localDate.getFullYear();
    const month = String(localDate.getMonth() + 1).padStart(2, '0'); // months are zero-indexed
    const day = String(localDate.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`; // Return in 'YYYY-MM-DD' format
  }

  private splitDate(date: any): string {
    const [day, month, year] = date.split('/');
    return `${year}-${month}-${day}`;
  }

  fetchWorkOrderById(id: number) {
    // this.workOrderService.getWorkOrderById(id).subscribe({
    //   next: (workorder) => {
    //     this.purchaseOrderForm.patchValue({
    //       projectId: workorder?.projectData?.id,
    //     });
    //   },
    //   error: (error) => {
    //     console.error(error, 'Error');
    //   },
    // });
  }

  calculateItemRatesAndDiscounts() {
    const additionalDiscountRaw =
      this.purchaseOrderForm.get('additionalDiscount')?.value;

    const additionalDiscount = Number(additionalDiscountRaw) || 0;

    const itemsArray = this.items as FormArray;

    const totalNetPrice = itemsArray.controls.reduce(
      (total, control: AbstractControl) => {
        const item = control.value;
        const netPrice = item.subTotal - item.discount;
        return total + netPrice;
      },
      0
    );

    const validatedTotalNetPrice = totalNetPrice !== 0 ? totalNetPrice : 1;

    this.newPurchaseItems.map((item: any) => {
      const netPrice = item.netPrice || 0;
      console.log('netPrice', netPrice);

      item.splDiscount =
        (additionalDiscount * netPrice) / validatedTotalNetPrice;
      console.log('splDiscount', item.splDiscount);

      const discount = item.discount + item.splDiscount;
      console.log('item.discount', item.discount);

      item.rate = (netPrice - discount) / item.quantity;

      item.netPrice = item.rate * item.quantity - item.discount;

      item.vatAmount = item.netPrice * 0.05;
    });

    // this.purchaseOrderForm.get('additionalDiscount')?.setValue(null, { emitEvent: false });
  }

  preferenceCode(search: string = '') {
    this.preferenceService.fetchPreferenceCodes(search, 'Purchase Order').subscribe({
      next: (response) => {
        response.forEach((prefix: any) => {
          this.purchaseOrderNo = prefix?.sequenceCode;
        });
        // this.prefix = `${this.purchaseOrderNo}`;
        this.purchaseOrderForm.patchValue({ purchaseOrderNo: this.purchaseOrderNo });
      },
      error: (error) => {
        console.error(error, 'Error');
      },
    });
  }
  preventEnterKey(event: KeyboardEvent): void {
    if (event.key === 'Enter') {
      event.preventDefault();
      console.log('Enter key press prevented.');
    }
  }

  openCreateVendorDialog() {
    // const dialogRef = this.dialog.open(CreateVendorDialog, {
    //   disableClose: true,
    // });

    // dialogRef.afterClosed().subscribe((result) => {
    //   if (result === 'success') {
    //   }
    //   this.fetchPartners();
    // });
  }

  onSubSubjectSearch(event: Event): void {
    const inputValue = (event.target as HTMLInputElement).value.toLowerCase();
    this.filteredSubSubjectList = this.subSubjectList.filter((sub) =>
      sub.toLowerCase().includes(inputValue)
    );
    // Allow manual input if it doesn't match the filtered list
    if (!this.filteredSubSubjectList.includes(inputValue) && inputValue) {
      this.filteredSubSubjectList.push(inputValue);
    }
  }

  loadPurchaseOrderData() {
    if (this.purchaseOrderId != null) {
      this.purchaseOrderService
        .fetchPurchaseOrder(this.purchaseOrderId)
        .subscribe({
          next: (data) => {
            this.purchaseOrderData = data;
            console.log("purchaseOrderData", this.purchaseOrderData);
            this.newPurchaseItems = data.purchaseItems;
            const billDate = new Date(Number(this.purchaseOrderData?.billDate));
            const formattedDate = `${billDate
              .getDate()
              .toString()
              .padStart(2, '0')}/${(billDate.getMonth() + 1)
              .toString()
              .padStart(2, '0')}/${billDate.getFullYear()}`;
            const vendor = this.fetchPartners(
              this.purchaseOrderData?.vendorId,
              ''
            );

            this.purchaseOrderForm.patchValue({
              PurchaseType: this.purchaseOrderData?.PurchaseType,
              vendorId: this.purchaseOrderData?.vendorId,
              purchaseOrderNo: this.purchaseOrderData?.purchaseOrderNo,
              trnNumber: this.purchaseOrderData?.vendor?.trn,
              reference: this.isCancelling
                ? this.purchaseOrderData?.purchaseOrderNo // <-- set reference = old PO no
                : this.purchaseOrderData?.reference,
              currency: this.purchaseOrderData?.currencyId,
              // workorderId: {
              //   workOrderId: this.purchaseOrderData?.workorderData?.id,
              //   workOrderNo: this.purchaseOrderData?.workorderData?.workOrderNo,
              //   projectName: this.purchaseOrderData?.project?.projectName,
              //   projectId: this.purchaseOrderData?.project?.id,
              // },
              // paymentTerms: this.purchaseOrderData?.paymentTerms,
              // shipmentPreference: this.purchaseOrderData?.shippmentInstructions,
              // subject: this.purchaseOrderData?.subject,
              // customerNotes: this.purchaseOrderData?.customerNote,
              billDate: formattedDate, //Date
              // billingAddressId: this.purchaseOrderData?.billingAddressData?.id,
              // shippingAddressId:
              //   this.purchaseOrderData?.shippingAddressData?.id,
              // discountType:
              //   this.purchaseOrderData?.isFlat === true ? 'flat' : 'percentage',
              additionalDiscount: this.purchaseOrderData?.discount,
              // isVat: this.purchaseOrderData?.isVatable,
              // customerId: this.purchaseOrderData?.customerId,
            });
            this.items.clear();

        // Populate FormArray with fetched items
        this.newPurchaseItems.forEach(item => {
          this.items.push(this.fb.group({
            itemName: [item.itemName, Validators.required],
            description: [item.description || ''],
            quantity: [item.quantity, [Validators.required, quantityValidator]],
            rate: [item.rate, Validators.required],
            subTotal: [ item.rate * item.quantity],
            tax: [item.tax || 0],
            totalAmount: [item.totalAmount || 0],
            // Add other necessary fields matching your formGroup definition
          }));
        });
            // this.isCustomerSelected = this.purchaseOrderData?.customerId !== 0;
            this.selectedAddress =
              this.purchaseOrderData?.vendor.address;
            // this.selectedShippingAddress =
            //   this.purchaseOrderData?.shippingAddressData;

            // if (data.purchaseItems) {
            //   data.purchaseItems.forEach((item: any, index: any) => {
            //     this.newPurchaseItems[index].vatAmount = item.vat;
            //     this.newPurchaseItems[index].itemName = item.name;
            //     this.calculateLogic();
            //   });
            // }
            // this.updateSelectedWorkOrderDisplay(this.purchaseOrderForm.get('workorderId')?.value)
          },
        });
    }
  }

  get items(): FormArray {
    return this.purchaseOrderForm.get('items') as FormArray;
  }

  private fetchItems(search: string = '', filter: any = {}) {
    const updatedFilter = {
      ...filter,
      isPurchaseActive: true,
    };

    // this.itemService.fetchItems(search, updatedFilter).subscribe({
    //   next: (items) => {
    //     this.itemData = items;
    //     this.filteredItemData = items;
    //   },
    //   error: (error) => console.error(error),
    // });
  }

  // Method to handle vendor selection and update TRN number
  onVendorChange(vendorId: string) {
    const selectedVendor = this.vendorsData.find(
      (vendor) => vendor.id === vendorId
    );
    if (selectedVendor) {
      this.selectedVendorTRN = selectedVendor.trn || '';
      this.selectedAddress = selectedVendor.address;
      this.purchaseOrderForm.get('trnNumber')?.setValue(this.selectedVendorTRN);
      this.purchaseOrderForm.get('shippingAddressId')?.setValue(this.selectedAddress);
      this.purchaseOrderForm.get('billingAddressId')?.setValue(this.selectedAddress);
    }
  }
  onWorkOrderChange(event: any): void {
    if (event?.projectId) {
      this.projectId = event?.projectId 
      this.checkProjectThresholdValidation(this.projectId);
    }
    this.updateSelectedWorkOrderDisplay(event);
  }

  updateSelectedWorkOrderDisplay(workOrder: any): void {
    this.selectedWorkOrderDisplay = `${workOrder?.workOrderNo || 'NA'} - ${workOrder?.projectName || 'NA'}`;
  }

  compareWorkOrders = (o1: any, o2: any): boolean => {
    return o1?.workOrderId === o2?.workOrderId;
  };

  private checkProjectThresholdValidation(id: number | null = null, totalAmount: number = 0) {
    // this.purchaseOrderService
    //   .checkProjectThresholdValidation(Number(id))
    //   .subscribe({
    //     next: (data) => {
    //       this.amount = data?.amount;
    //       console.log('total amount', this.amount + totalAmount);
    //       console.log('project cost', data?.project?.totalProjectCost * (data?.project?.threshold/100));
          
    //       if((this.amount + totalAmount) > (data?.project?.totalProjectCost * (data?.project?.threshold/100))){
    //         this.toastr.warning(`Amount exceeds the total project cost`, 'Warning');
    //         this.thresholdExceeds = true;
    //       }
    //     },
    //     error: (error) => console.error(error), 
    //   });
  }
  // FETCH VENDORS
  private fetchPartners(id: number | null = null, search: string = '') {
    this.vendorInvoiceService.fetchVendors(search).subscribe({
      next: (data) => {
        // console.log(data);
        this.vendorsData = data;
      },
      error: (err) => {
        console.log(err);
      },
    });
  }

  removeItem(index: number): void {
    this.items.removeAt(index);
  }

  private fetchCustomers(search: string = '') {
    this.invoiceService
      .fetchCustomers(search)
      .subscribe({
        next: (partners) => {
          this.cutomersData = partners.map((data: any) => ({
            id: data.id || '--',
            name: data.firstName+' '+data.lastName || '--',
            addresses: data.addresses || [],
          }));
          if (this.purchaseOrderData) {
            this.purchaseOrderForm.patchValue({
              customerId: this.purchaseOrderData.customerId,
            });
          }
        },
        error: (error) => console.error(error),
      });
  }

  getAdditionalDiscount(): number {
    const totalAmount = this.getTotalAmount(); // Amount before VAT
    const additionalDiscount = parseFloat(
      this.purchaseOrderForm.get('additionalDiscount')?.value || '0'
    );
    const discountType = this.purchaseOrderForm.get('discountType')?.value;

    if (discountType === 'percentage') {
      return (totalAmount * additionalDiscount) / 100;
    }

    return additionalDiscount; // Flat discount
  }

  getTotalAmount(): number {
    // Calculate total for newly added items
    const newItemsTotal = this.items.controls.reduce((total, itemGroup) => {
      const rate = parseFloat(itemGroup.get('rate')?.value || '0');
      const quantity = parseFloat(itemGroup.get('quantity')?.value || '0');
      const discount = parseFloat(itemGroup.get('discount')?.value || '0');
      const subTotal = rate * quantity;
      return total + (subTotal - discount); // Total after discount
    }, 0);

    // Calculate total for already added items in purchaseOrderData
    const existingItemsTotal = this.purchaseOrderData?.purchaseItems.reduce(
      (total: any, item: any) => {
        const rate = parseFloat(item.rate || '0');
        const quantity = parseFloat(item.quantity || '0');
        const discount = parseFloat(item.discount || '0');
        const subTotal = rate * quantity;
        return total + (subTotal - discount); // Total after discount
      },
      0
    );

    // Return combined total
    return newItemsTotal + (existingItemsTotal || 0);
  }

  getSubTotal(): number {
    // Calculate subtotal for newly added items
    const newItemsSubtotal = this.items.controls.reduce((subtotal, item) => {
      const quantity = parseFloat(item.get('quantity')?.value || '0');
      const rate = parseFloat(item.get('rate')?.value || '0');
      return subtotal + quantity * rate;
    }, 0);

    // Calculate subtotal for already added items in purchaseOrderData
    const existingItemsSubtotal = this.purchaseOrderData?.purchaseItems.reduce(
      (subtotal: any, item: any) => {
        const quantity = parseFloat(item.quantity || '0');
        const rate = parseFloat(item.rate || '0');
        return subtotal + quantity * rate;
      },
      0
    );

    // Return the total subtotal
    return newItemsSubtotal + (existingItemsSubtotal || 0);
  }

  getDiscount(): number {
    // Calculate discount for newly added items
    const newItemsDiscount = this.items.controls.reduce(
      (discount, itemGroup) => {
        return discount + parseFloat(itemGroup.get('discount')?.value || '0');
      },
      0
    );

    // Calculate discount for already added items
    const existingItemsDiscount = this.purchaseOrderData?.purchaseItems.reduce(
      (discount: any, item: any) => {
        return discount + parseFloat(item.discount || '0');
      },
      0
    );

    // Return total discount
    return newItemsDiscount + (existingItemsDiscount || 0);
  }

  getVAT(): number {
    const isVatEnabled = this.purchaseOrderForm.get('isVat')?.value;
    if (!isVatEnabled) {
      return 0.0;
    }
    const totalAfterDiscount = this.getTotalAmount();
    return (totalAfterDiscount * 5) / 100;
  }

  getGrandTotal(): number {
    const totalAfterDiscount =
      this.getTotalAmount() - this.getAdditionalDiscount();
    const vat = this.getVAT();
    return totalAfterDiscount + vat; // Grand Total = Discounted Total + VAT
  }

  calculateAmount(itemGroup: FormGroup): void {
    const rate = parseFloat(itemGroup.get('rate')?.value || '0');
    const quantity = parseFloat(itemGroup.get('quantity')?.value || '0');
    const discount = parseFloat(itemGroup.get('discount')?.value || '0');

    const subTotal = rate * quantity; // Subtotal = rate * quantity
    let netPrice = subTotal - discount; // Total after discount

    const vatRate = 5;
    let vatAmount = 0;
    if (this.purchaseOrderForm.get('isVat')?.value) {
      vatAmount = parseFloat((netPrice * 0.05).toFixed(2));
    }

    const total = netPrice + Number(vatAmount);
    itemGroup.patchValue({ subTotal, vatAmount, total, netPrice });
  }

  setAdminAddress() {
    // this.purchaseOrderService.fetchAdminAdress().subscribe({
    //   next: (data) => {
    //     if (data && data.length > 0) {
    //       this.selectedCustomerId = data[0]?.partnerId ?? null;
    //     } else {
    //       console.error('No admin address found or empty address array.');
    //     }
    //     this.selectedBillingAddress = data.find(
    //       (address: any) => address.addressType === 'BILLING'
    //     );
    //     this.selectedShippingAddress = data.find(
    //       (address: any) => address.addressType === 'SHIPPING'
    //     );
    //     this.purchaseOrderForm.patchValue({
    //       billingAddressId: this.selectedBillingAddress?.id || null,
    //       shippingAddressId: this.selectedShippingAddress?.id || null,
    //     });
    //   },
    //   error: (err) => {
    //     console.error('Error fetching admin adrress:', err); // Handle errors gracefully
    //   },
    // });
  }

  toggleCustomer() {
    this.isCustomerSelected = true;
    this.selectedAddress = '';
    this.selectedShippingAddress = '';
  }

  toggleOrgainization() {
    this.isCustomerSelected = false;
    this.selectedAddress = '';
    this.selectedShippingAddress = '';
    this.setAdminAddress();
  }
  openSelectBillingAddressDialog() {
    const selectedCustomerId = this.purchaseOrderData?.customerId
      ? this.purchaseOrderData?.customerId
      : this.adminPartnerId;

    console.log({ selectedCustomerId });

    const type = 'BILLING';

    // const dialogRef = this.dialog.open(ListBillingAddressDialog, {
    //   data: {
    //     selectedCustomerId,
    //     type,
    //   },
    // });

    // dialogRef.afterClosed().subscribe((address) => {
    //   if (address) {
    //     this.selectedBillingAddress = address;
    //     this.purchaseOrderForm.patchValue({ billingAddressId: address.id });
    //   }
    // });
  }

  openSelectShippingAddressDialog() {
    const selectedCustomerId = this.purchaseOrderData?.customerId
      ? this.purchaseOrderData?.customerId
      : this.adminPartnerId;
    const type = 'SHIPPING';

    // const dialogRef = this.dialog.open(ListShippingAddressDialog, {
    //   data: {
    //     selectedCustomerId,
    //     type,
    //   },
    // });
    // dialogRef.afterClosed().subscribe((address) => {
    //   if (address) {
    //     this.selectedShippingAddress = address;
    //     this.purchaseOrderForm.patchValue({ shippingAddressId: address.id });
    //   }
    // });
  }

  openBillingAddressDialog(type: any) {
    const selectedClientId = this.selectedCustomerId;
    // this.dialog.open(BillingAddressDialog, {
    //   width: '400px',
    //   data: {
    //     clientId: selectedClientId,
    //     type,
    //   },
    // });
  }

  openShippingAddressDialog(type: any) {
    const selectedClientId = this.selectedCustomerId;
    // this.dialog.open(ShippingAddressDialog, {
    //   width: '400px',
    //   data: {
    //     clientId: selectedClientId,
    //     type,
    //   },
    // });
  }

  onCustomerChange(event: MatSelectChange): void {
    this.selectedCustomerId = event.value; // Get the selected customer ID
    const selectedCustomer = this.cutomersData.find(
      (customer) => customer.id === this.selectedCustomerId
    );

    if (selectedCustomer && selectedCustomer.addresses) {
      // Find billing address
      const billingAddress = selectedCustomer.addresses.find(
        (address: any) => address.addressType === 'BILLING'
      );
      this.selectedAddress = billingAddress || null;

      // Find shipping address
      const shippingAddress = selectedCustomer.addresses.find(
        (address: any) => address.addressType === 'SHIPPING'
      );
      this.selectedShippingAddress = shippingAddress || null;

      // Update the form with the selected addresses
      this.purchaseOrderForm.patchValue({
        billingAddressId: this.selectedAddress?.id || null,
        shippingAddressId: this.selectedAddress?.id || null,
      });
    } else {
      console.error('No addresses found for the selected customer.');
      this.selectedAddress = null;
      this.selectedAddress = null;
    }
  }

  onItemSearch(event: Event): void {
    const input = event.target as HTMLInputElement;
    const searchTerm = input.value;

    if (searchTerm) {
      this.fetchItems(searchTerm);
    } else {
      this.filteredItemData = this.itemData;
    }
  }

  onCancel(): void {
    this.purchaseOrderForm.reset();
    this.router.navigate(['/purchase-order']);
  }

  fetchWorkOrders(search: string | null = ''): void {
    const searchTerm = search ?? ''; // Convert null to empty string
    // this.workOrderService.getAllWorkOrders(searchTerm).subscribe({
    //   next: (workorders) => {
    //     this.filteredWorkOrders = workorders;
    //   },
    //   error: (error) => console.error(error),
    // });
  }

  saveAsDraft(): void {
    this.status = 'DRAFT';
    this.purchaseOrderForm.get('additionalDiscount')?.updateValueAndValidity();
    this.createPurchaseOrder('purchase-order');
  }

  saveAndSend(): void {
    this.status = 'OPEN';
    this.purchaseOrderForm.get('additionalDiscount')?.updateValueAndValidity();
    this.createPurchaseOrder('purchase-order');
  }

  createPurchaseOrder(navigateTo: string): void {
    if (this.purchaseOrderForm.invalid) {
      const formValues = this.purchaseOrderForm.value;
      this.purchaseOrderForm.markAllAsTouched();
      const invalidFields: any = [];
      Object.keys(this.purchaseOrderForm.controls).forEach((field) => {
        const control = this.purchaseOrderForm.get(field);
        if (control && control.invalid) {
          invalidFields.push(field);
        }
      });
      this.toastr.warning('Please fill in all required fields.');
      return;
    } else {
      if (!this.purchaseOrderId) {
        // Only check for items if you're creating a new purchase order
        if (
          !this.purchaseOrderForm.value.items ||
          this.purchaseOrderForm.value.items.length === 0
        ) {
          this.toastr.warning(
            'Please add at least one item to the purchase order.'
          );
          return;
        }
      }
      const formValues = this.purchaseOrderForm.value;

      // Process subSubjectList from items
      // const subSubjectList = formValues.items
      //   .flatMap((item: any) => item?.subject || [])
      //   .filter((sub: string) => sub)
      //   .join(',');

      const createPurchaseOrderInput = {
        vendorId: formValues.vendorId,
        tax: this.totalVat,
        subTotal: this.subTotal,
        totalAmount: this.grandTotal,
        projectId: formValues.projectId,
        currencyId: this.selectedCurrencyId,
        purchaseStatus: this.status,
        purchaseOrderNo:formValues?.purchaseOrderNo,
        reference: formValues.reference,
        billDate: this.splitDate(formValues.billDate),
        // purchaseItems:this.items,
        dueDate: formValues.dueDate,
        customerNote: formValues.customerNotes,
        discount: formValues.additionalDiscount,
      };

      // const newPurchaseItemInput = this.newPurchaseItems.map((item: any) => {
      //   return {
      //     itemId: item.itemId
      //       ? item.itemId
      //       : item.isManual
      //       ? null
      //       : item.selectItem, // Manual entry, so set itemId to null
      //     name: item.itemName, // Set the manually typed item name
      //     isManual: item.itemId ? false : item.isManual,
      //     purchaseAccountId: null,
      //     unit: item.unit,
      //     quantity: item.quantity.toString(),
      //     balanceQuantity: item.quantity.toString(),
      //     rate: item?.rate.toString(),
      //     discount: item.discount || 0,
      //     amount:
      //       item?.rate * item?.quantity - item?.discount + item?.vatAmount,
      //     subjectList: item.itemId ? item.subjectList : item?.subject,
      //     vat: item?.vatAmount,
      //     measure: item.itemId ? item.measure : item?.measurement,
      //     actualRate: item.actualRate,
      //     splDiscount: item?.splDiscount,
      //   };
      // });

      this.loading = true;
      const purchaseOrderInput = {
        ...createPurchaseOrderInput,
        // purchaseItems: this.items,    
        purchaseItems: this.items.getRawValue().map((item: any) => ({
          ...item,
          quantity: parseFloat(item.quantity),
          rate: parseFloat(item.rate),
        }))
      };
      const updatedPurchaseOrderInput = {
        ...purchaseOrderInput,
        id: this.purchaseOrderId
      }
      if (this.purchaseOrderId) {
        if (this.items.length === 0) {
          this.toastr.warning(
            'Please add at least one item to the purchase order.'
          );
          this.loading = false;
          return;
        }

        // if (this.isCancelling) {
        //   this.purchaseOrderService
        //     .cancelAndCreatePO(
        //       this.purchaseOrderId,
        //       createPurchaseOrderInput,
        //       newPurchaseItemInput,
        //       // this.thresholdExceeds
        //     )
        //     .subscribe({

        //       next: (response) => {
        //         this.toastr.success('Purchase order updated successfully.');
        //         const purchaseId =
        //           response?.data?.cancelAndCreatePurchaseOrder?.id;
        //         if (purchaseId) {
        //           this.purchaseOrderService
        //             .generatepurchasepdf(purchaseId)
        //             .subscribe({
        //               next: (resp) => {
        //                 this.loading = false;
        //                 this.router.navigate([`${navigateTo}`], {
        //                   queryParams: { id: purchaseId },
        //                 });
        //                 const pdfUrl = resp?.generatePurchasePdf;
        //                 if (pdfUrl) {
        //                   this.toastr.success(
        //                     resp.message || 'Successfully generated pdf.'
        //                   );
        //                   // this.router.navigate([`${navigateTo}/${purchaseId}`]);
        //                 }
        //               },
        //               error: (error) => {
        //                 this.toastr.error(
        //                   error.message || 'Failed to generate pdf.'
        //                 );
        //               },
        //             });
        //         } else {
        //           console.error('Purchase order id is missing');
        //         }
        //       },
        //       error: (error) => {
        //         this.loading = false;
        //         console.error('Error updating purchase order :', error);
        //         this.toastr.error(
        //           error.message || 'Failed to update purchase order. '
        //         );
        //       },
        //     });
        // } else {
          this.purchaseOrderService
            .updatePurchaseOrder(
              this.purchaseOrderId,
              updatedPurchaseOrderInput, 
              // this.thresholdExceeds
            )
            .subscribe({
              next: (response) => {
                this.toastr.success('Purchase order updated successfully.');
                // const purchaseId = response?.data?.updatePurchaseOrder?.id;
                // if (purchaseId) {
                //   this.purchaseOrderService
                //     .generatepurchasepdf(purchaseId)
                //     .subscribe({
                //       next: (resp) => {
                //         this.loading = false;
                //         this.router.navigate([`${navigateTo}`], {
                //           queryParams: { id: purchaseId },
                //         });
                //         const pdfUrl = resp?.generatePurchasePdf;
                //         if (pdfUrl) {
                //           this.toastr.success(
                //             resp.message || 'Successfully generated pdf.'
                //           );
                          this.router.navigate([`${navigateTo}`]);
                //         }
                //       },
                //       error: (error) => {
                //         this.toastr.error(
                //           error.message || 'Failed to generate pdf.'
                //         );
                //       },
                //     });
                // } else {
                //   console.error('Purchase order id is missing');
                // }
              },
              error: (error) => {
                this.loading = false;
                console.error('Error updating purchase order :', error);
                this.toastr.error(
                  error.message || 'Failed to update purchase order. '
                );
              },
            });
        // }
      } 
      else {
        if (this.items.length 
          === 0) {
          this.toastr.warning(
            'Please add at least one item to the purchase order.'
          );
          this.loading = false;
          return;
        }
        this.purchaseOrderService
          .createPurchaseOrder(purchaseOrderInput)
          .subscribe({
            next: (response) => {
              this.toastr.success('Purchase order created successfully');
              // const purchaseId = response?.data?.createPurchaseOrder?.id;
              // if (purchaseId) {
              //   // this.purchaseOrderService.markAsIssued(purchaseId);
              //   this.purchaseOrderService
              //     .generatepurchasepdf(purchaseId)
              //     .subscribe({
              //       next: (resp) => {
              //         this.loading = false;
              //         // this.router.navigate([`${navigateTo}/${purchaseId}`]);
              //         const pdfurl = resp?.generatePurchasePdf;
              //         if (pdfurl) {
              //           this.toastr.success(
              //             resp.message || 'Successfully generated pdf.'
              //           );
              //         }
                      this.router.navigate([`${navigateTo}`]);
                    // },
              //       error: (err) => {
              //         this.toastr.error(
              //           err.message || 'Failed to generate pdf.'
              //         );
              //       },
              //     });
              // }
            },
            error: (error) => {
              this.loading = false;
              this.toastr.error(
                error.message || 'Failed to create purchase-order.'
              );
            },
          });
      }
    }
  }

  listCurrencies(search: string = '', filter: any = {}) {
    this.currencyService.fetchCurrencies(this.search, this.filter).subscribe({
      next: (currency) => {
        this.allCurrencies = currency;
        const aedCurrency = this.allCurrencies.find(
          (c: { currencyCode: string }) => c.currencyCode === 'AED'
        );
        if (aedCurrency) {
          this.purchaseOrderForm.get('currency')?.setValue(aedCurrency.id, {
            emitEvent: true, // ensures valueChanges subscription runs
          });
          this.selectedCurrencyCode = aedCurrency.currencyCode || 'AED';
          this.selectedCurrencyId = aedCurrency.id;
        }
      },
      error: (error) => console.error(error),
    });
  }

  getUpdatePurchaseOrderItemInput() {
    return this.items.controls.map((itemGroup) => {
      const id = itemGroup.get('id')?.value;
      const itemId = itemGroup.get('selectItem')?.value;
      const isManual = itemGroup.get('isManual')?.value;
      const name = itemGroup.get('itemName')?.value;
      const quantity = itemGroup.get('quantity')?.value;
      const balanceQuantity = itemGroup.get('quantity')?.value;
      const rate = itemGroup.get('rate')?.value;
      const discount = itemGroup.get('discount')?.value;
      const amount = itemGroup.get('total')?.value;
      const purchaseAccountId = null;
      const unit = itemGroup.get('unit')?.value;
      const vat = itemGroup.get('vatAmount')?.value;
      // const subjectList = itemGroup.get('subject')?.value;

      const existingPurchaseOrderItem =
        this.purchaseOrderData?.purchaseItems?.find(
          (purchaseorderItem: any) => purchaseorderItem.itemId === itemId
        );

      return {
        // id: existingPurchaseOrderItem ? existingPurchaseOrderItem.id : null, // Existing item gets id; new item gets null
        itemId: itemId || null, // Ensure itemId is set correctly
        name:
          name ||
          (existingPurchaseOrderItem ? existingPurchaseOrderItem.name : ''),
        isManual: !!isManual,
        quantity,
        balanceQuantity,
        unit,
        rate,
        discount,
        amount,
        purchaseAccountId,
        // subjectList,
        vat,
      };
    });
  }

  onRemoveInvoiceItem(index: number, itemId: number): void {
    if (itemId) {
      const dialogRef = this.dialog.open(ConfirmDialog);
      dialogRef.afterClosed().subscribe((response) => {
        if (response === true) {
          this.removeItemFormLits(itemId, index);
        }
      });
    } else {
      console.error('Item ID is null or undefined');
      this.items.removeAt(index);
    }
  }

  private removeItemFormLits(itemId: number, index: number): void {
    // this.purchaseOrderService.removePurchaseOrderItem(itemId).subscribe({
    //   next: () => {
    //     this.toastr.success('Purchase Order removed successfully.');
    //     console.log('Purchase Order  item removed successfully');

    //     // Ensure `purchaseOrderData` and `purchaseItems` are replaced immutably
    //     this.purchaseOrderData = {
    //       ...this.purchaseOrderData, // Clone the parent object
    //       purchaseItems: [
    //         ...this.purchaseOrderData.purchaseItems.slice(0, index),
    //         ...this.purchaseOrderData.purchaseItems.slice(index + 1),
    //       ],
    //     };
    //   },
    //   error: () => {
    //     this.toastr.error('Failed to remove purchase order item.');
    //     console.log('Failed to remove purchase order item.');
    //   },
    // });
  }

  openDialog() {
    const itemsArray = this.purchaseOrderForm.get('items') as FormArray;
    const uniqueSubjects = [
      ...new Set(itemsArray.value.map((item: any) => item.subject)),
    ];

  }

  findOriginalNetPrice(items: any[]): number {
    let originalNetPrice = 0;
    items.forEach((item: any) => {
      originalNetPrice += item.actualRate * item.quantity - item.discount;
    });
    return originalNetPrice;
  }

  // calculateLogic() {
  //   // this.subTotal = 0;
  //   this.totalDiscount = 0;
  //   // this.totalVat = 0;
  //   // this.grandTotal = 0;
  //   const originalNetPrice = this.findOriginalNetPrice(this.newPurchaseItems);
  //   const additionalDiscountRaw =
  //     this.purchaseOrderForm.get('additionalDiscount')?.value || 0;
  //   this.additionalDiscount = additionalDiscountRaw;
  //   this.newPurchaseItems.forEach((item: any) => {
  //     console.log({ item });

  //     this.subTotal = this.subTotal + item.actualRate * item.quantity;
  //     this.totalDiscount = this.totalDiscount + (item.discount || 0);
  //     if (additionalDiscountRaw > 0) {
  //       const ItemNetPrice = item.actualRate * item.quantity - item.discount;
  //       item.splDiscount =
  //         (additionalDiscountRaw * (ItemNetPrice / originalNetPrice)) /
  //         item.quantity;
  //       item.rate = item.actualRate - item.splDiscount;
  //       item.amount =
  //         item.rate * item.quantity - item.discount + item.vatAmount;
  //     } else {
  //       item.rate = item.actualRate;
  //       item.splDiscount = 0;
  //       item.amount =
  //         item.rate * item.quantity - item.discount + item.vatAmount;
  //     }

  //     item.vatAmount =
  //       item.vatAmount > 0
  //         ? 0.05 * (item.rate * item.quantity - item.discount)
  //         : 0;
  //     // item.vatAmount = item.vat;
  //     this.totalVat += item.vatAmount;
  //   });
  //   this.totalDiscount = this.totalDiscount + additionalDiscountRaw;
  //   const netPrice = this.subTotal - this.totalDiscount;
  //   this.grandTotal = netPrice + this.totalVat;
  // }

  calculateLogic() {
    this.subTotal = 0;
    this.totalVat = 0;
    this.totalDiscount = 0;
    this.additionalDiscount = +this.purchaseOrderForm.get('additionalDiscount')?.value || 0;
  
    this.items.controls.forEach(itemGroup => {
      const rate = +itemGroup.get('rate')?.value || 0;
      const quantity = +itemGroup.get('quantity')?.value || 0;
      const discount = +itemGroup.get('discount')?.value || 0;
  
      const subTotalItem = rate * quantity;
      const vatItem = (subTotalItem - discount) * 0.05; // VAT on net line
  
      this.subTotal += subTotalItem;
      this.totalVat += vatItem;
      this.totalDiscount += discount;
    });
  
    // (this.subTotal - this.totalDiscount - this.additionalDiscount) + this.totalVat
    this.grandTotal = this.subTotal - this.totalDiscount - this.additionalDiscount + this.totalVat;
  }
  
  removeNewPurchaseItem(index: number): void {
    if (index > -1) {
      this.newPurchaseItems.splice(index, 1); // Removes the item at the specified index
    }
    this.calculateLogic();
  }

  allowOnlyInteger(event: KeyboardEvent): void {
    const inputChar = String.fromCharCode(event.keyCode || event.which);

    // Allow only digits 0-9
    if (!/^[0-9]$/.test(inputChar)) {
      event.preventDefault();
    }
  }

  blockPasteNonInteger(event: ClipboardEvent): void {
    const pastedInput: string = event.clipboardData?.getData('text') || '';
    // Allow only digits, no decimal or special chars
    if (!/^\d+$/.test(pastedInput)) {
      event.preventDefault();
    }
  }

  allowOnlyNumberWithDecimal(event: KeyboardEvent): void {
    const inputChar = String.fromCharCode(event.keyCode || event.which);

    // Allow digits and decimal point
    if (!/^[0-9.]$/.test(inputChar)) {
      event.preventDefault();
      return;
    }

    // Disallow more than one decimal point
    const input = event.target as HTMLInputElement;
    if (inputChar === '.' && input.value.includes('.')) {
      event.preventDefault();
    }
  }

  blockPaste(event: ClipboardEvent): void {
    const pastedInput: string = event.clipboardData?.getData('text') || '';
    if (!/^\d*\.?\d*$/.test(pastedInput)) {
      event.preventDefault();
    }
  }

  onRemoveNewlyAddedItems(index: number): void {
    this.items.removeAt(index);
    this.updateOverallSummary();
  }

  updateOverallSummary(): void {
    this.subTotal = 0;
    this.totalVat = 0;
    this.totalDiscount = 0;
    this.grandTotal = 0;
    const items = this.purchaseOrderForm.get('items') as FormArray;
    let subTotal = 0;
    let tax = 0;

    items.controls.forEach((item) => {
      subTotal += parseFloat(item.get('subTotal')?.value) || 0;
      tax += parseFloat(item.get('tax')?.value) || 0;
    });

    const discount =
      parseFloat(this.purchaseOrderForm.get('additionalDiscount')?.value) || 0;
    const totalAmount = subTotal + tax - discount;

    this.subTotal = subTotal;
    this.totalVat = tax;
    this.totalDiscount = discount;
    this.grandTotal = totalAmount;
  }

  addItem(): void {
      const itemGroup = this.fb.group({
        purchaseOrderId : [this.purchaseOrderId],
        itemName: ['', Validators.required],
        description: [''],
        quantity: [
          1,
          [
            Validators.required,
            Validators.pattern(/^\d+(\.\d+)?$/),
            quantityValidator,
          ],
        ],
        rate: [0, Validators.required],
        subTotal: [0],
        tax: [0],
        totalAmount: [0],
      });
  
      this.items.push(itemGroup);
  
      // Auto calculate on change
      itemGroup.valueChanges.subscribe((value) => {
        const quantity = parseFloat((value.quantity ?? '0').toString()) || 0;
        const rate = parseFloat((value.rate ?? '0').toString()) || 0;
        // const quantity = parseFloat(value.quantity) || 0;
        // const rate = parseFloat(value.rate) || 0;
        const subTotal = quantity * rate;
        const tax = subTotal * 0.05;
        const totalAmount = subTotal + tax;
  
        itemGroup.patchValue(
          {
            subTotal,
            tax,
            totalAmount,
          },
          { emitEvent: false }
        );
  
        this.calculateLogic();
      });
      this.calculateLogic();
    }

  getNewTotalAmount(): number {
    return this.newPurchaseItems.reduce((total, item) => {
      const rate = parseFloat(item.rate) || 0;
      const quantity = parseFloat(item.quantity) || 0;
      const discount = item.discount || 0;
      return total + (rate * quantity - discount);
    }, 0);
  }

  getNewSubTotal(): number {
    const newItemsSubtotal = this.newPurchaseItems.reduce((subtotal, item) => {
      const quantity = parseFloat(item.quantity || '0');
      const rate = parseFloat(item.actualRate || '0');
      return subtotal + quantity * rate;
    }, 0);

    const existingItemsSubtotal = this.purchaseOrderData?.purchaseItems.reduce(
      (subtotal: any, item: any) => {
        const quantity = parseFloat(item.quantity || '0');
        const rate = parseFloat(item.rate || '0');
        return subtotal + quantity * rate;
      },
      0
    );

    return newItemsSubtotal + (existingItemsSubtotal || 0);
  }

  getNewDiscount(): void {
    const newItemsDiscount = this.newPurchaseItems.reduce((discount, item) => {
      return discount + (parseFloat(item.discount) || 0);
    }, 0);

    const existingItemsDiscount = this.purchaseOrderData?.purchaseItems.reduce(
      (discount: any, item: any) => {
        return discount + parseFloat(item.discount || '0');
      },
      0
    );

    // Get the additional discount from the form and log it
    const additionalDiscount = parseFloat(
      this.purchaseOrderForm.get('additionalDiscount')?.value || '0'
    );
    // Add the additional discount to the total discount
    this.totalDiscount =
      newItemsDiscount + (existingItemsDiscount || 0) + additionalDiscount;
  }

  getNewVat(): number {
    const vatRate = 5; // VAT percentage (5%)

    // Calculate VAT for new items
    const newItemsVat = this.newPurchaseItems.reduce((total, item) => {
      const quantity = parseFloat(item.quantity) || 0;
      const rate = parseFloat(item.rate) || 0;
      const discount = parseFloat(item.discount) || 0;
      const vatAmount = parseFloat(item.vatAmount) || 0; // vatAmount field to check if VAT should be applied
      const grossPrice = quantity * rate - discount;

      // If vatAmount > 0, apply VAT, else skip VAT calculation
      const itemVatAmount = vatAmount > 0 ? (grossPrice * vatRate) / 100 : 0;
      return total + itemVatAmount;
    }, 0);

    // Calculate VAT for existing items (if any)
    const existingItemsVat = this.purchaseOrderData?.purchaseItems.reduce(
      (total: number, item: any) => {
        const quantity = parseFloat(item.quantity) || 0;
        const rate = parseFloat(item.rate) || 0;
        const discount = parseFloat(item.discount) || 0;
        const vatAmount = parseFloat(item.vat) || 0; // vatAmount field to check if VAT should be applied
        const grossPrice = quantity * rate - discount;

        // If vatAmount > 0, apply VAT, else skip VAT calculation
        const itemVatAmount = vatAmount > 0 ? (grossPrice * vatRate) / 100 : 0;
        return total + itemVatAmount;
      },
      0
    );

    return newItemsVat + (existingItemsVat || 0); // Return the total VAT for all items
  }

  getNewGrandTotal(): number {
    const additionalDiscount = parseFloat(
      this.purchaseOrderForm.get('additionalDiscount')?.value || '0'
    );
    const vatPercentage = 5; // VAT percentage (e.g., 5%)

    // Calculate the total of new purchase items (gross price after discount)
    const newItemsTotal = this.newPurchaseItems.reduce((total, item) => {
      const rate = parseFloat(item.rate) || 0;
      const quantity = parseFloat(item.quantity) || 0;
      const discount = parseFloat(item.discount) || 0;
      const grossPrice = rate * quantity - discount; // Gross price after discount
      return total + grossPrice;
    }, 0);

    // Calculate the total of existing items (gross price after discount)
    const existingItemsTotal =
      this.purchaseOrderData?.purchaseItems.reduce(
        (total: number, item: any) => {
          const rate = parseFloat(item.rate || '0');
          const quantity = parseFloat(item.quantity || '0');
          const discount = parseFloat(item.discount || '0');
          const grossPrice = rate * quantity - discount; // Gross price after discount
          return total + grossPrice;
        },
        0
      ) || 0;
    const netPrice = newItemsTotal + existingItemsTotal;
    const discountedPrice = Math.max(0, netPrice - additionalDiscount);

    const vatAmount = this.getNewVat();
    const grandTotal = discountedPrice + vatAmount;

    return grandTotal;
  }

  validateAdditionalDiscount(
    control: AbstractControl
  ): ValidationErrors | null {
    const additionalDiscount = control.value;
    if (additionalDiscount > this.grandTotal) {
      return { additionalDiscountInvalid: true }; // Return error
    }
    return null; // No error
  }
}

// @Component({
//   selector: 'add-items-dialog',
//   templateUrl: './add-items-dialog.html',
//   styleUrls: ['./purchase-order-new.component.scss'],
//   standalone: true,
//   imports: [
//     MatDialogModule,
//     MatButtonModule,
//     MatFormFieldModule,
//     MatInputModule,
//     MatSelectModule,
//     ReactiveFormsModule,
//     MatOptionModule,
//     CommonModule,
//     NgxMatSelectSearchModule,
//     MatIconModule,
//     MatAutocompleteModule,
//   ],
// })
// export class AddItemsDialog {
//   showFirstField: boolean = true;
//   itemData: any;
//   filteredItemData: any;
//   itemGroup: FormGroup;
//   selectedItem: string = '';
//   formGroup!: FormGroup;
//   allItems: any[];
//   unitTypes: any = UNITTYPES;
//   subjects: string[] = [];

//   constructor(
//     @Inject(MAT_DIALOG_DATA) public data: any,
//     private dialogRef: MatDialogRef<AddItemsDialog>,
//     private fb: FormBuilder,
//     private itemService: InventoryItemService,
//     private purchaseOrderService: PurchaseOrdereService
//   ) {
//     this.allItems = [];
//     this.subjects = (data.uniqueSubjects || []).filter(
//       (subject: string) => subject && subject.trim() !== ''
//     );
//     console.log(data);

//     this.itemGroup = this.fb.group({
//       selectItem: [null],
//       itemName: ['', Validators.required],
//       // quantity: [
//       //   1,
//       //   [
//       //     Validators.required,
//       //     Validators.min(1),
//       //     // Validators.pattern('^[0-9]+(.[0-9]{1,3})?$'), // Updated for decimal validation
//       //     Validators.pattern('^[1-9][0-9]*$')
//       //   ],
//       // ],
//       quantity: [
//         1,
//         this.data.isLocalPurchaseOrder
//           ? [Validators.required, Validators.pattern('^[0-9]+(.[0-9]{1,2})?$')] // decimal validation
//           : [
//               Validators.required,
//               Validators.min(1),
//               Validators.pattern('^[1-9][0-9]*$'),
//             ], // no decimal
//       ],
//       isManual: [true],
//       unit: ['', Validators.required],
//       rate: [
//         0,
//         [
//           Validators.required,
//           Validators.pattern('^[0-9]+(.[0-9]{1,2})?$'), // Updated for decimal validation
//           Validators.min(0), // Ensure rate is not negative
//         ],
//       ],
//       subTotal: [
//         0,
//         [
//           Validators.required,
//           Validators.min(0),
//           Validators.pattern(/^\d+(\.\d+)?$/), // Added decimal validation
//         ],
//       ],
//       discount: [
//         0,
//         [
//           Validators.pattern(/^\d+(\.\d+)?$/),
//           this.discountLessThanOrEqualToSubTotal(), // Added decimal validation
//         ],
//       ],
//       netPrice: [0, Validators.required],
//       vatAmount: [
//         0,
//         [Validators.pattern(/^\d+(\.\d+)?$/), this.validateVatAmount()],
//       ],
//       total: [0, [Validators.required]],
//       subject: [],
//       measurement: [''],
//       actualRate: [],
//       splDiscount: [0],
//     });
//   }

//   ngOnInit(): void {
//     this.fetchItems();
//     // this.fetchSubjects();

//     // const savedSubjects = localStorage.getItem('subjects');
//     // if (savedSubjects) {
//     //   this.subjects = JSON.parse(savedSubjects); // Parse and set subjects from localStorage
//     // }

//     this.itemGroup.get('quantity')?.valueChanges.subscribe(() => {
//       this.calculateAmount(this.itemGroup);
//     });

//     this.itemGroup.get('rate')?.valueChanges.subscribe(() => {
//       this.calculateAmount(this.itemGroup);
//     });

//     this.itemGroup.get('discount')?.valueChanges.subscribe(() => {
//       this.calculateAmount(this.itemGroup); // Recalculate when discount changes
//     });

//     this.itemGroup.get('vatAmount')?.valueChanges.subscribe((value) => {
//       this.calculateAmount(this.itemGroup, true); // Mark VAT as manually updated
//     });

//     this.itemGroup.get('discount')?.valueChanges.subscribe(() => {
//       this.itemGroup.updateValueAndValidity(); // Trigger validation manually
//     });
//   }

//   validateVatAmount(): ValidatorFn {
//     return (control: AbstractControl): ValidationErrors | null => {
//       const subTotal = this.itemGroup?.get('subTotal')?.value || 0;
//       const discount = this.itemGroup?.get('discount')?.value || 0;
//       const vat = control.value;
//       const netPrice = subTotal - discount;

//       const validVatAmounts = [0, parseFloat((netPrice * 0.05).toFixed(2))];

//       // Check if VAT is either 0 or 5% of subtotal
//       return validVatAmounts.includes(vat)
//         ? null
//         : { invalidVat: 'VAT must be either 0 or 5%' };
//     };
//   }

//   onItemSearch(event: Event): void {
//     const searchValue = (event.target as HTMLInputElement).value.trim();

//     this.filteredItemData = this.allItems?.filter((item: any) =>
//       item.itemName.toLowerCase().includes(searchValue.toLowerCase())
//     );

//     if (
//       !this.filteredItemData.some((item: any) => item.itemName === searchValue)
//     ) {
//       this.itemGroup.patchValue({
//         selectItem: null,
//       });
//     }
//   }
//   // Custom Validator: Discount should be less than or equal to SubTotal
//   discountLessThanOrEqualToSubTotal(): ValidatorFn {
//     return (control: AbstractControl): ValidationErrors | null => {
//       const group = control as any;
//       const discount = this.itemGroup?.get('discount')?.value;
//       const subTotal = this.itemGroup?.get('subTotal')?.value;

//       // Return an error if discount is greater than subTotal
//       if (discount !== null && subTotal !== null && discount > subTotal) {
//         return { discountTooHigh: true };
//       }

//       return null; // No error
//     };
//   }
//   onSelectItem(event: MatAutocompleteSelectedEvent): void {
//     const selectedItemName = event.option.value; // Get the selected item's name
//     const selectedItem = this.filteredItemData.find(
//       (item: any) => item.itemName === selectedItemName
//     );

//     if (selectedItem) {
//       this.itemGroup.patchValue({
//         selectItem: selectedItem.id,
//         itemName: selectedItem.itemName,
//         rate: selectedItem.costPrice,
//         quantity: 1,
//         isManual: false,
//         unit: 'nos',
//       });

//       this.calculateAmount(this.itemGroup);
//     }
//   }

//   calculateAmount(itemGroup: FormGroup, manualVat = false): void {
//     const rate = parseFloat(itemGroup.get('rate')?.value) || 0;
//     const quantity = parseFloat(itemGroup.get('quantity')?.value) || 0;
//     const discount = parseFloat(itemGroup.get('discount')?.value) || 0;
//     let vatAmount = parseFloat(itemGroup.get('vatAmount')?.value) || 0;

//     const subTotal = rate * quantity;
//     const netPrice = subTotal - discount;

//     if (!manualVat) {
//       const vatRate = 5;
//       vatAmount = parseFloat((netPrice * (vatRate / 100)).toFixed(2));
//     }

//     const total = vatAmount === 0 ? netPrice : netPrice + vatAmount;
//     itemGroup.patchValue(
//       { subTotal, vatAmount, total, netPrice },
//       { emitEvent: false } // Prevent infinite loop
//     );
//   }

//   private fetchItems(search: string = '', filter: any = {}) {
//     const updatedFilter = {
//       ...filter,
//       isPurchaseActive: true,
//     };

//     this.itemService.fetchItems(search, updatedFilter).subscribe({
//       next: (items) => {
//         this.itemData = items;
//         this.filteredItemData = items;
//       },
//       error: (error) => console.error(error),
//     });
//   }

//   onSubmit(): void {
//     if (this.itemGroup.valid) {
//       const subjectValue = this.itemGroup.get('subject')?.value;
//       const rateValue = Number(this.itemGroup.get('rate')?.value);
//       this.itemGroup.patchValue({ actualRate: rateValue });

//       if (subjectValue) {
//         this.subjects.push(subjectValue);
//         // localStorage.setItem('subjects', JSON.stringify(this.subjects));
//       }
//       this.dialogRef.close(this.itemGroup.value);
//       this.itemGroup.patchValue({ subject: '' });
//     }
//   }

//   private getPurchaseItems() {
//     return this.itemGroup.value;
//   }
//   onCancel(): void {
//     this.dialogRef.close();
//   }
//   toggleField(): void {
//     if (!this.showFirstField) {
//       this.itemGroup.get('subject')?.setValue(this.subjects[0] || '');
//     }
//     this.showFirstField = !this.showFirstField;
//   }
//   preventEnterKey(event: KeyboardEvent): void {
//     if (event.key === 'Enter') {
//       event.preventDefault();
//       console.log('Enter key press prevented.');
//     }
//   }
// }
